var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationMoments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.61768 13.1208C5.61768 8.97694 8.97693 5.61768 13.1208 5.61768H31.8786C36.0224 5.61768 39.3816 8.97694 39.3816 13.1208V31.8786C39.3816 36.0225 36.0224 39.3818 31.8786 39.3818H13.1208C8.97693 39.3818 5.61768 36.0225 5.61768 31.8786V13.1208Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 30.0035L31.1023 21.401C32.5673 19.9366 34.9421 19.9366 36.4071 21.401L39.3819 24.3761",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0588 16.8737C15.6128 16.8737 16.8725 15.614 16.8725 14.06C16.8725 12.5061 15.6128 11.2463 14.0588 11.2463C12.5048 11.2463 11.2451 12.5061 11.2451 14.06C11.2451 15.614 12.5048 16.8737 14.0588 16.8737Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28027 34.9625L14.2148 27.0279C15.6798 25.5633 18.0545 25.5633 19.5195 27.0279L31.5564 39.0648",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationMoments);
export default __webpack_public_path__ + "static/media/navigation-moments.aebaf762.svg";
export { ForwardRef as ReactComponent };